function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "14",
  height: "14",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M7 0c3.87 0 7 3.131 7 7 0 3.87-3.131 7-7 7-3.87 0-7-3.131-7-7 0-3.87 3.131-7 7-7zm0 1.094A5.903 5.903 0 001.094 7 5.903 5.903 0 007 12.906 5.903 5.903 0 0012.906 7 5.903 5.903 0 007 1.094zm-.017 2.953a.5.5 0 01.492.41l.008.09-.001 2.335h1.645a.5.5 0 01.492.41l.008.09a.5.5 0 01-.41.493l-.09.008H6.983a.5.5 0 01-.492-.41l-.008-.09V4.547a.5.5 0 01.5-.5z",
  fill: "#54585D",
  fillRule: "nonzero"
})));